import { render } from "./TooltipInfoTrigger.vue?vue&type=template&id=61844b68&lang=pug"
import script from "./TooltipInfoTrigger.vue?vue&type=script&setup=true&lang=js"
export * from "./TooltipInfoTrigger.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__